import React from 'react';
import Helpers from './Helpers.js'

//import BlickHeader from './BlickHeader.js';
//import BlickFooter from './BlickFooter.js';
import Button from './Button.js';
import ElectionView from './ElectionView.js';

import header from './img/header.png'
import './UsWahl.css';
import './tv.css';

class UsWahl extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			data: 				null,
			ready: 				false,
			update: 			null,
			year_active_index: 	null,
			year_active_name: 	"",
			start_year_index: 	0,
			show: 				"results",
			years:				[
				 {
					id: 				"2016",
					is_active:			false,
					is_loaded:			false,
					is_preprocessed: 	false,
					data: 				null,
				},
				{
					id: 				"2020",
					is_active:			false,
					is_loaded:			false,
					is_preprocessed:	false,
					data: 				null,
				},
			],
			mode: "full",
			debug: false,
			error: false,
			channel:"default",
			element: "all"
		}
		this.setYear = this.setYear.bind(this)
		this.togglePolls = this.togglePolls.bind(this)
	}

	urlVars() {
		// YEAR
		let yearIndex = [];
		let dsy = "2020"
		let sy = dsy;
		this.state.years.map((year, key) => {
			yearIndex.push(year.id)
			return false;
		});
		let urlYear = Helpers.getUrlVar("year");
		if(urlYear!==false) {
			if(yearIndex.indexOf(urlYear+"")>-1){
				sy = urlYear
			}
			else {
				sy = dsy;
			}
		}
		else {
			sy = dsy;	
		}
		this.setState(
			{"start_year_index":yearIndex.indexOf(sy)}
		)	

		// MODE
		let md = "full";
		let urlMode = Helpers.getUrlVar("mode");
		if(urlMode==="full" || urlMode === "light") {
			md = urlMode;
			this.setState(
				{"mode":md}
			)
		}

		// SHOW POLLS OR RESULTS
		let shw = this.state.show;
		let urlShw =  Helpers.getUrlVar("show");
		if(urlShw==="polls" || urlShw === "results") {
			shw = urlShw;
			this.setState(
				{"show":shw}
			)
		}

		// TV
		let channel = this.state.channel;
		let urlChannel =  Helpers.getUrlVar("channel");
		if(urlChannel==="tv") {
			channel = "tv";
			this.setState(
				{"channel":channel}
			)
		}

		// Element
		let element = this.state.element;
		let urlElement =  Helpers.getUrlVar("element");
		if(urlElement==="bars" || urlElement === "map") {
			element = urlElement;
			this.setState(
				{"element":element}
			)
		}




		// DEBUG
		let db = false;
		let urlDebug = Helpers.getUrlVar("debug");
		if(urlDebug==="true") {
			db = true;
			this.setState(
				{"debug":db}
			)
		}
	}

	
	componentDidMount() {
		this.urlVars();
		this.fetchData();

		
	}

	assignPolls(polls,id) {
		if(polls.hasOwnProperty(id)){
			return polls[id].poll;
		}
		else {
			return "";
		}
	}

	preProcess(data) {

		let new_state = JSON.parse(JSON.stringify(this.state));

		// TOTALS
		let totals = {
			votes: 0,
			electors: 0,
			states: 0,
			candidates: 0,
			attributed: {
				votes: 0,
				electors: 0,
				states: 0,
				candidates: 0,
				percent: 0,
				others: {
					votes: 0,
					electors: 0,
					percent: 0
				},
				favorites: {
					votes: 0,
					electors: 0,
					percent: 0
				}
			},
			all_electors: 0
		}

		// NOTES
		let notes = [];
		data['notes'].map((item, key) => {
			notes.push(item)
			return false
		})


		// ELECTORS
		const states_elector_count = {};
		data['states-electors'].map((item, key) => {
			states_elector_count[item.state] = item;
			//totals.electors+=item.electors*1;
			totals.all_electors+=item.electors*1;
			return false
		})


		// PARTIES 
		let parties = {
			o: {},
			a: []
		}
		
		// PARTY-INFO
		const parties_info = {};
		data['parties'].map((item, key) => {
			let party = {
				id: item.name,
				name: item.name,
				partycode: item.code,
				candidates: {
					o: {},
					a: []
				},
				ticket: {
					president: item.ticket_president,
					vice_president: item.ticket_vice_president
				}
			};

			parties_info[item.name] = item;
			parties.o[item.name] = party;

			return false
		})

		// POLLS-LABELS
		const polls = {};
		this.state.data['poll-labels'].map((item, key) => {
			item.electors = 0;
			polls[item.id] = item;
			return true;
		})

	
		// POLLS per state
		const state_polls = {};
		data['polls'].map((item, key) => {
			polls[item.poll].electors += states_elector_count[item.state].electors*1;
			state_polls[item.state] = item;
			return true;
		})
		this.setState(
			{polls:polls}
		)

		// STATES
		let states = {
			o: {},
			a: [],
			dict: {}
		}

		this.state.data['states'].map((item, key) => {
			let staat = item;
			staat.electors = states_elector_count[item.name].electors;
			staat.polls = this.assignPolls(state_polls,item.name);
			staat.counted = 0;
			staat.notes = "";
			staat.parties = {
				o: {},
				a: []
			 };		 	
			 staat.candidates = {
				o: {},
				a: [],
				winner: "none"
			 };
			 staat.totals = {
				 votes: 0,
				 electors: staat.electors,
				 attributed: {
					 electors: 0,
					 votes: 0
				 }
			 }
		 	states.o[item.name] = staat;
			states.a.push(staat);
			states.dict[item.id] = staat.name;
		 	return false
		})


		// CANDIDATES 
		let candidates = {
			o: {},
			a: []
		}


		// CANDIDATES-INFO
		const candidates_info = {};
		data['candidates'].map((item, key) => {
			candidates_info[item.name] = item;

			let candidate = {
				id: item.name,
				name: item.name,
				votes: 0,
				percent: 0,
				electors: 0,
				aux: {
					votes: null,
					percent: null,
					electors: null,
				},
				note: item.note,
				party: item.partei,
				portrait: "default",
				winner: item.winner,
				home: item.home,
				dob: item.dob
			}
			if(item.portrait.length>3) {
				candidate.portrait = this.state.year_active_name+"/"+item.portrait;
			}
			candidates.o[candidate.id] = candidate;
			return false
		})



		data['results'].map((item, key) => {
			if(item.candidate.length<=0 || item.party.length<=0) {
				item.candidate = "Andere";
				item.party = "Andere"
			}
			let party = {
				id: item.party,
				name: item.party,
				partycode: parties_info[item.party].code,
				candidates: {
					o: {},
					a: []
				},
				ticket: {
					president: parties_info[item.party].ticket_president,
					vice_president: parties_info[item.party].ticket_vice_president
				}
			};

			if(!parties.o.hasOwnProperty(party.name)) {
				parties.o[party.name] = party;
				//parties.a.push(party)				
			}

			if(states.o.hasOwnProperty(item.state)) {
				let party = {
					id: item.party,
					name: item.party,
					partycode: parties_info[item.party].code,
					candidates: {
						o: {},
						a: []
					},
					ticket: {
						president: parties_info[item.party].ticket_president,
						vice_president: parties_info[item.party].ticket_vice_president
					}
				};	
			
				// Candidate in State			
				if(!states.o[item.state].candidates.o.hasOwnProperty(item.candidate)) {
					let candidate = {
						id: item.candidate,
						name: item.candidate,
						votes: item.votes*1,
						percent: item.percent*1,
						electors: item.aux_electors*1,
						aux: {
							votes: null,
							percent: null,
							electors: null,
						},
						note: item.note,
						party: party.id,
						portrait: "default",
						winner: 0
					}
					if(candidates_info.hasOwnProperty(item.candidate)) {
						candidate.portrait = this.state.year_active_name+"/"+candidates_info[item.candidate].portrait;
						candidate.winner = candidates_info[item.candidate].winner;
					}
					states.o[item.state].candidates.o[item.candidate] = candidate;
					states.o[item.state].totals.votes += candidate.votes*1;
					states.o[item.state].totals.attributed.electors += candidate.electors*1;
					if(item.counted.length>0) {
						states.o[item.state].counted = item.counted;
					}
				}
				if(states.o[item.state].id!=="me-1" && states.o[item.state].id!=="me-2" && states.o[item.state].id!=="ne-1" && states.o[item.state].id!=="ne-2" && states.o[item.state].id!=="ne-3") {

					if(candidates_info.hasOwnProperty(item.candidate)) {
						if(candidates_info[item.candidate].votes.length<=0) {
							totals.votes += item.votes*1;
							totals.attributed.votes = totals.votes;
						}
						if(item.candidate!==parties.o["Democratic Party"].ticket.president && item.candidate!==parties.o["Republican Party"].ticket.president) {
							if(candidates_info[item.candidate].votes.length<=0) {
								totals.attributed.others.votes += item.votes*1;
							}
						}
						else {
							if(candidates_info[item.candidate].votes.length<=0) {
								totals.attributed.favorites.votes += item.votes*1;
								totals.attributed.votes = totals.votes;
								}
							}				
					}
					else {
						totals.votes += item.votes*1;
						totals.attributed.votes = totals.votes;
						totals.attributed.others.votes += item.votes*1;
					}
				}
				if(item.note.length>0) {
					states.o[item.state].notes += item.note+" ";
				}
			}

			// CANDIDATE IN CANDIDATES
			if(!candidates.o.hasOwnProperty(item.candidate)) {
				let candidate = {
					id: item.candidate,
					name: item.candidate,
					votes: item.votes*1,
					percent: 0,
					electors: item.aux_electors*1,
					
					aux: {
						votes: null,
						percent: null,
						electors: null,
					},

					note: item.note,
					party: party.id,
					portrait: "default",
					winner: 0
				}
				if(candidates_info.hasOwnProperty(item.candidate)) {
					candidate.portrait = this.state.year_active_name+"/"+candidates_info[item.candidate].portrait
					candidate.winner = candidates_info[item.candidate].winner;
				}
				candidates.o[item.candidate] = candidate;
				//candidates.a.push(candidate);
			}
			else {
				if(states.o[item.state].id!=="me-1" && states.o[item.state].id!=="me-2" && states.o[item.state].id!=="ne-1" && states.o[item.state].id!=="ne-2" && states.o[item.state].id!=="ne-3") {
					candidates.o[item.candidate].votes += item.votes*1
				}
//				if(item.state!=="")
				/// ????????? ---------->
				//candidates.o[item.candidate].electors += item.aux_electors*1
			}	
		 	return false
		})
		Helpers.o2a(parties.o).items.map((item,k) => {
			parties.a.push(item)
			return false
		})



		// OVERRIDE STATEWIDE VOTES AND ELECTORS AND PERCENTS
		Helpers.o2a(candidates.o).items.map((candidate,k) => {
			if(candidates_info.hasOwnProperty(candidate.id)) {
				if(candidates_info[candidate.id].votes.length>1) {
					candidate.aux.votes = candidates_info[candidate.id].votes
					totals.votes += candidates_info[candidate.id].votes*1
					totals.attributed.votes += candidates_info[candidate.id].votes*1
					if(candidate.id!==parties.o["Democratic Party"].ticket.president && candidate.id!==parties.o["Republican Party"].ticket.president) {
						totals.attributed.others.votes += candidates_info[candidate.id].votes*1;
					}
					else {
						totals.attributed.favorites.votes += candidates_info[candidate.id].votes*1;
					}
				}
				if(candidates_info[candidate.id].electors.length>0) {
					candidate.aux.electors = candidates_info[candidate.id].electors
					totals.electors += candidates_info[candidate.id].electors*1
					totals.attributed.electors += candidates_info[candidate.id].electors*1
					if(candidate.id!==parties.o["Democratic Party"].ticket.president && candidate.id!==parties.o["Republican Party"].ticket.president) {
						totals.attributed.others.electors += candidates_info[candidate.id].electors*1;
					}
					else {
						totals.attributed.favorites.electors += candidates_info[candidate.id].electors*1;
					}	
				} 
				if(candidates_info[candidate.id].percent.length>1) {
					candidate.aux.percent = candidates_info[candidate.id].percent;
				}
			}
			return false
		})

		Helpers.o2a(states.o).items.map((staat,k) => (
			Helpers.o2a(staat.candidates.o).items.map((candidate,k) => (
				staat.candidates.a.push(candidate)
			))
		))
	
		// ASSIGN ELECTORS PER STATE
		Helpers.o2a(states.o).items.map((staat,k) => {
			if(staat.totals.votes*1>10 || staat.totals.attributed.electors>0) {
				if(staat.candidates.a.length>0) {
					if(staat.totals.attributed.electors>0) {
						staat.candidates.a = Helpers.sorting(staat.candidates.a,"electors",-1)
					}
					else {
						staat.candidates.a = Helpers.sorting(staat.candidates.a,"votes",-1)
					}
					if(staat.candidates.a[0].hasOwnProperty('name')) {
						staat.candidates.winner = staat.candidates.a[0].name;
						staat.candidates.a[0].electors = states.o[staat.name].electors;
						if(candidates_info.hasOwnProperty(staat.candidates.a[0].name) && candidates_info[staat.candidates.a[0].name].electors.length>0) {
							return false
						}
						else {
							totals.electors += states.o[staat.name].electors*1;
						}
						//return staat.candidates.a[0].name
						return false
					}
					else {
						staat.candidates.winner = "none"
					}
				}
				else {
					staat.candidates.winner = "none"
				}
			}
			else {
				staat.candidates.winner = "none"
			}
			return true
		})

		// ASSIGN ELECTORS PER CANDIDATE
		Helpers.o2a(states.o).items.map((staat,k) => {
			if(staat.candidates.winner!=="none" && staat.candidates.winner.length>3) {
				if(candidates.o.hasOwnProperty(staat.candidates.winner) && staat.hasOwnProperty("electors")) {
					if(candidates_info.hasOwnProperty(staat.candidates.winner)) {
						if(candidates_info[staat.candidates.winner].electors.length<=0) {
							
							candidates.o[staat.candidates.winner].electors += Number(staat.electors);
							totals.attributed.electors += Number(staat.electors);
							
							if(staat.candidates.winner!==parties.o["Democratic Party"].ticket.president && staat.candidates.winner!==parties.o["Republican Party"].ticket.president) {
								totals.attributed.others.electors += Number(staat.electors);
							}
							else {
								totals.attributed.favorites.electors += staat.electors*1;
							}
						}						
					}
					else {
						totals.attributed.favorites.electors += staat.electors*1;
					}
				}
			}
			return false
		})

		Helpers.o2a(candidates.o).items.map((candidate,k) => {
			candidate.percent = 0;
			if(candidate.aux.electors!==null) {
				candidate.electors = candidate.aux.electors
			}
			if(candidate.aux.votes!==null) {
				candidate.votes = candidate.aux.votes
			}
			if(candidate.aux.percent!==null) {
				candidate.percent = candidate.aux.percent
			}
			else {
				candidate.percent = Helpers.getPercent(totals.votes,candidate.votes)
			}
			if(parties.o.hasOwnProperty("Democratic Party") && parties.o.hasOwnProperty("Republican Party") ) {
				if(candidate.id!==parties.o["Democratic Party"].ticket.president && candidate.id!==parties.o["Republican Party"].ticket.president) {
					totals.attributed.others.percent += Number(candidate.percent)
				}
				else {
					totals.attributed.favorites.percent += Number(candidate.percent)
				}				
			}
			else {
				totals.attributed.favorites.percent += Number(candidate.percent)
			}	
			totals.attributed.percent += Number(candidate.percent)
			candidates.a.push(candidate)
			return false;
		})

		totals.attributed.percent = Math.round(totals.attributed.percent*100)/100
		totals.attributed.favorites.percent = Math.round(totals.attributed.favorites.percent*100)/100
		totals.attributed.others.percent = Math.round(totals.attributed.others.percent*100)/100

		parties.a = Helpers.sorting(parties.a,"name",1);
		states.a = Helpers.sorting(states.a,"name",1)
		candidates.a = Helpers.sorting(candidates.a,"name",1)
		candidates.a = Helpers.sorting(candidates.a,"votes",-1)
		candidates.a = Helpers.sorting(candidates.a,"electors",-1)

		totals.electors_to_win = Math.round(totals.all_electors)/2+1


		new_state.years[new_state.year_active_index].data.parties = parties;
		new_state.years[new_state.year_active_index].data.states = states;
		new_state.years[new_state.year_active_index].data.candidates = candidates;
		new_state.years[new_state.year_active_index].data.totals = totals;
		new_state.years[new_state.year_active_index].data.notes = notes;
		new_state.years[new_state.year_active_index].data.polls = polls;
		this.setState(new_state);
	}

	fetchData() {
		fetch("./data/data_bulk.json")
			.then(response => response.json())
			.then(
				(response) => {
					this.setState({
						"data": response.data,
						"update": response.meta.update
					})
					this.setYear(this.state.start_year_index)
				},
				// Note: it's important to handle errors here
				// instead of a catch() block so that we don't swallow
				// exceptions from actual bugs in components.
				(error) => {
					this.setState({
						error: true,
						ready: false
					}
				);
			}
		)
	}

	togglePolls(index) {
		this.setState({
			show: index
		})
	}

	fetchYear(index) {
		let new_state = JSON.parse(JSON.stringify(this.state));
		new_state.year_active_index = index;
		new_state.year_active_name = new_state.years[index].id;
		let d = new Date();
		let cacheBuster = (d.getMonth()+1)+"-"+d.getDate()+"-"+d.getHours()+"-"+d.getMinutes();
		fetch("./data/data_"+new_state.year_active_name+".json?"+cacheBuster)
			.then(response => response.json())
			.then(
				(response) => {
					new_state.years[new_state.year_active_index].data = {};
					new_state.years[new_state.year_active_index].is_loaded = true;
					new_state.years[new_state.year_active_index].is_preprocessed = false;
					new_state.ready = true;
					this.setState(new_state)
					this.preProcess(response.data)

					//
				},
				// Note: it's important to handle errors here
				// instead of a catch() block so that we don't swallow
				// exceptions from actual bugs in components.
				(error) => {
					console.log("error")
					this.setState({
						error: true,
						ready: false
					});
				}
			)
	}

	setYear(index) {
		this.fetchYear(index)
	}

	render() {
		let className = "UsWahl";
		if(this.state.channel==="tv") {
			className = className+" tv"
			if(this.state.element==="bars" || this.state.element==="map") {
				className = className+ " tv-"+this.state.element;
			}
		}
		if(this.state.ready===true) {
			return(
				<div className={className}>
					{
						//<BlickHeader title= { "U.S.-Vorwahlen "+ this.state.year_active_name }  />
					}

					<div className={'BlickMainContent '+this.state.mode}>
						<div className='usWahlAltHeader'>
							<h1>{ "US-Präsidentschaftswahl "+ this.state.year_active_name }</h1>
						</div>
						
						<div className='usWahlHeader'>
							<img src={header} alt={ "US-Präsidentschaftswahl "+ this.state.year_active_name } />
							<div className='headerH1Box'>
								<h1>US-Präsidentschaftswahl {this.state.year_active_name }</h1>
							</div>
							<div className='YearMenu menu'>
							{
								this.state.years.map((year, key) => {
									return(
										<Button
											index =   			{key }
											key = 				{key}
											name = 				{year.id }
											ready =				{this.state.ready}
											active_index = 		{this.state.year_active_index}
											button_handler =	{this.setYear}
										>
										</Button>
									)
								})
							}
							</div>
						</div>
						
						<ElectionView
							title =						"Elections"
							data = 						{this.state.years[this.state.year_active_index].data}
							year = 						{this.state.year_active_name}
							mode = 						{this.state.mode}
							debug = 					{this.state.debug}
							poll_toggle_handler =		{this.togglePolls}
							active_index = 				{this.state.show}
							show = 						{this.state.show}

						>
						</ElectionView>


						<div className='usWahlFooter'>
							<div className='byline'>
								© 2020 Blick Visuals, rtp | Quellen: 270towin.com, AP, realclearpolitics.com, nytimes.com, TheGreenPapers.com
								| Aktualisiert: {this.state.update} 
								
							</div>
						</div>
					</div>
					{
						//<BlickFooter byline="© 2020 Blick Visuals, rtp | Quelle: nytimes.com" />
					}
				</div>
			)

		}
		else {
			return (
				<div className='loader'>
					Loading…
				</div>
				)
		}
	}


}

export default UsWahl;
